import React from 'react';

import Breeder from './components/Breeder';
import Trainer from './components/Trainer';
import Owner from './components/Owner';
import Age from './components/Age';
import Sire from './components/Sire';
import Dam from './components/Dam';
import DamSire from './components/DamSire';

const GenericDetails = props => (
    <div className="hp-details__data">
        <div className="hp-details__section">
            <Age key="Age" {...props} />
            <Breeder key="Breeder_xn" {...props} className="hidden-md-up" />
            <Trainer key="Trainer" {...props} />
            <Owner key="Owner" {...props} />
        </div>
        <div className="hp-details__section">
            <div className="hp-details__extraData">
                <Sire key="Sire" {...props} />
                <Dam key="Dam" {...props} />
                <DamSire key="DamSire" {...props} />
            </div>
            <Breeder key="Breeder" {...props} className="hidden-sm-down" />
        </div>
    </div>
);

export default GenericDetails;



// WEBPACK FOOTER //
// ./src/js/horse/details/GenericDetails.jsx